
















































































































































































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { MAX_BLANKS_COUNT, QUESION_TYPES } from '@/enums';
import Utils from '@/shared/utils';
import { Blank } from '../../../types/questions.type';

@Component
export default class BlanksAnswers extends Vue {
  @Prop(String) readonly questionText!: string;

  @Prop() readonly blanks!: Blank[];

  @Prop(Number) readonly questionCaseSensitive!: number;

  errors: { [panelIndex: number]: string } = {};

  submitError = '';

  opened: number[] = [0];

  MAX_BLANKS_COUNT = MAX_BLANKS_COUNT;

  QUESION_TYPES = QUESION_TYPES;

  onCaseSensitiveChangedHandler() {
    this.panels.forEach((_, index) => {
      this.checkForDuplicates(index);
    });
    const valid = this.validateBlanksPanelsChange();
    this.$emit('case-sensitive-changed', {
      caseSensitive: this.caseSensitive,
      blanks: this.panels,
      valid,
    });
  }

  panels: Blank[] = [];

  caseSensitive = 0;

  $refs!: {
    form: HTMLFormElement;
  };

  mounted(): void {
    if (this.blanks && this.blanks.length > 0) {
      this.panels = this.blanks;
    } else {
      this.panels = [
        {
          answers: [{ text: '', degree: null }],
          blanksIndices: [],
          totalDegree: null,
        },
      ];
    }
    this.caseSensitive = this.questionCaseSensitive;
  }

  @Watch('panels', { deep: true })
  onBlanksPanelsChange(blanks: Blank[]): void {
    for (let i = 0; i < this.panels.length; i += 1) {
      this.reCalculatePanelTotalDegree(i);
    }
    const valid = this.validateBlanksPanelsChange();
    this.$emit('blanks-anwers-changed', { blanks, valid });
  }

  @Watch('questionText')
  onQuestionTextChange(): void {
    this.panels.forEach((_, i) => {
      this.panels[i].blanksIndices = this.panels[i].blanksIndices.filter((index) => this.blanksIndices.includes(index));
    });
  }

  validateBlanksPanelsChange(): boolean {
    let valid = true;
    this.panels.forEach((panel, index) => {
      const degrees = panel.answers.map((answer) => answer.degree as number);
      degrees.sort((a, b) => b - a);

      if (panel.blanksIndices?.length > 1 && panel.answers?.length < panel.blanksIndices?.length) {
        this.errors[index] = 'validations.OPTIONS_MUST_EQUAL_BLANKS';
        valid = false;
      } else if (
        this.invalidBlankGroupDegrees(panel) && panel.blanksIndices.length
      ) {
        this.errors[index] = 'validations.INVALID_MAX_BLANKS_DEGREES';
        valid = false;
      } else if (panel.answers?.length < 1 && panel.blanksIndices?.length <= 1) {
        this.errors[index] = 'validations.BLANKS_OPTIONS_REQUIRED';
        valid = false;
      } else {
        valid = this.checkForDuplicates(index);
        if (valid) this.errors[index] = '';
      }
    });

    if (this.submitError) {
      valid = this.validateForm() && valid;
    }

    return valid;
  }

  validateForm(): boolean {
    let valid = true;
    const nonSelectedIndices = this.getNonSelectedIndices();
    if (nonSelectedIndices.length > 0) {
      valid = false;
      this.submitError = 'validations.ALL_BLANKS_MUST_BE_SELECTED';
    } else {
      this.submitError = '';
    }

    return valid;
  }

  rules = {
    answer: [
      (v: string) => v.trim().length > 0 || this.$t('requiredField'),
      (v: string) => v.length <= 50 || this.$t('validations.maxLength', { max: 50 }),
    ],
    degree: [
      (val: number) => val >= 0.01 || this.$t('validations.minValue', { min: 0.01 }),
      (val: number) => val <= 999 || this.$t('validations.maxValue', { max: 999 }),
      (val: string) => /^\d{0,3}(?:\.\d{1,2})?$/.test(val) || this.$t('validations.maxFloating'),
    ],
    required: [(v: string) => v.length > 0 || this.$t('requiredField')],
  };

  checkForDuplicates(panelIndex: number): boolean {
    const uniqueAnswers = new Set();
    const duplicates: string[] = [];
    const answers = this.panels[panelIndex].answers.map((answer) => answer.text);

    answers.forEach((answer) => {
      if (answer) {
        const answerText = answer.replace(/\s+/g, ' ').trim();
        const normalizedAnswer = !this.caseSensitive
          ? Utils.normalizeString(answerText)
          : answerText;
        if (uniqueAnswers.has(normalizedAnswer)) {
          duplicates.push(answer);
        } else {
          uniqueAnswers.add(normalizedAnswer);
        }
      }
    });

    if (duplicates.length > 0) {
      this.errors[panelIndex] = 'validations.ANSWERS_CANNOT_BE_DUPLICATED';
      return false;
    }
    this.errors[panelIndex] = '';
    return true;
  }

  get blanksIndices() {
    const doc = new DOMParser().parseFromString(this.questionText, 'text/html');
    const blanks: Element[] = Array.from(doc.querySelectorAll('span.app-blank-placeholder'))
      .filter((span) => span.textContent === '');
    return blanks.map((_, index) => index);
  }

  getNonSelectedIndices(
    panelIndex: number | undefined = undefined,
  ): { index: number; value: number }[] {
    const selectedIndices = this.panels.flatMap((panel) => panel.blanksIndices) as number[];
    const nonSelectedIndices = this.blanksIndices.reduce((acc, blankIndex) => {
      if (!selectedIndices.includes(blankIndex)) {
        acc.push(blankIndex);
      }
      return acc;
    }, [] as number[]);
    const selected = this.panels[panelIndex as number]
      ? this.panels[panelIndex as number].blanksIndices
      : [];
    return [
      ...nonSelectedIndices.map((index) => ({ index, value: index + 1 })),
      ...selected.map((index) => ({ index, value: index + 1 })),
    ].sort((a, b) => a.index - b.index);
  }

  addPanel(): void {
    this.panels.push({
      answers: [{ text: '', degree: null }],
      blanksIndices: [],
      totalDegree: null,
    });
    this.opened = [this.panels.length - 1];
  }

  deletePanel(panelIndex: number): void {
    this.panels.splice(panelIndex, 1);
  }

  addAnswer(panelIndex: number): void {
    this.panels[panelIndex].answers.push({ text: '', degree: null });
  }

  removeAnswer(panelIndex: number, answerIndex: number): void {
    this.panels[panelIndex].answers.splice(answerIndex, 1);
  }

  reCalculatePanelTotalDegree(panelIndex: number): void {
    const degrees = this.getGroupBlankHighestNDegrees(this.panels[panelIndex]);
    this.panels[panelIndex].totalDegree = degrees.reduce((sum, val) => sum + val, 0);
  }

  getGroupBlankHighestNDegrees(blank: Blank): number[] {
    return blank.blanksIndices.length
      ? blank.answers
        .map((blankAnswer) => Number(blankAnswer.degree))
        .sort((a, b) => a - b)
        .slice(-1 * blank.blanksIndices.length)
      : [];
  }

  invalidBlankGroupDegrees(blank: Blank): boolean {
    const arr = Array.from(new Set(this.getGroupBlankHighestNDegrees(blank)));
    return arr.length > 1;
  }
}
